import styled from 'styled-components';
import { Avatar } from '@material-ui/core';

const SmallAvatar = styled(Avatar)`
    ${({ theme }) => `
        && {
            height: ${theme.spacing(4)}px;
            width: ${theme.spacing(4)}px;
        }
    `}
`;

export const MicroAvatar = styled(Avatar)`
    ${({ theme }) => `
        && {
            height: ${theme.spacing(3)}px;
            width: ${theme.spacing(3)}px;
        }
    `}
`;

export default SmallAvatar;
